import Card from '@packages/ui/card/card.tsx';
import CardHeader from '@packages/ui/card/card-header.tsx';
import CardContent from 'ui/src/card/card-content';
import { useTranslate } from '@tolgee/react';
import TextInput from '@packages/ui/form/input/text-input.tsx';
import FormItem from '@packages/ui/form/form-item.tsx';
import { Controller, useFormContext } from 'react-hook-form';
import PhoneInput from 'react-phone-number-input/min';
import FormLayout from '@packages/ui/form/form-layout.tsx';
import { CompanyForm } from '@client/page/management/company-settings/company-settings.tsx';

export default function CompanyImprintSetting() {
  const { t } = useTranslate();

  const {
    control,
    formState: { errors },
  } = useFormContext<CompanyForm>();

  return (
    <Card>
      <CardHeader title={'Imprint setting'} />

      <CardContent>
        <FormLayout>
          {/*Imprint */}
          <FormItem className="max-w-xl" title={t('company.imprint-setting.form-input.owner.title', 'Owner')}>
            <Controller
              name={'imprintOwner'}
              control={control}
              render={({ field }) => (
                <TextInput
                  type="text"
                  label="owner"
                  value={field.value ?? ''}
                  name="owner"
                  error={errors.imprintOwner?.message}
                  placeholder={t('company.imprint-setting.form-input.owner.placeholder', 'Owner')}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>

          {/*Google*/}
          <FormItem
            className="max-w-xl"
            title={t('company.imprint-setting.form-input.owner-tax-id.title', 'Owner tax id')}
          >
            <Controller
              name={'imprintOwnerTaxId'}
              control={control}
              render={({ field }) => (
                <TextInput
                  type="text"
                  label="owner-tax-id"
                  value={field.value ?? ''}
                  name="owner-tax-id"
                  error={errors.imprintOwnerTaxId?.message}
                  placeholder={t('company.imprint-setting.form-input.owner-tax-id.placeholder', 'Tax id')}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>
          {/*Imprint company Name*/}
          <FormItem
            className="max-w-xl"
            title={t('company.imprint-setting.form-input.company-name.title', 'Company name')}
          >
            <Controller
              name={'imprintCompanyName'}
              control={control}
              render={({ field }) => (
                <TextInput
                  type="text"
                  label="imprintCompanyName"
                  value={field.value ?? ''}
                  name="imprintCompanyName"
                  error={errors.imprintCompanyName?.message}
                  placeholder={t('company.imprint-setting.form-input.company-name.placeholder', 'Company Name')}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>

          {/*Comp tax id*/}
          <FormItem
            className="max-w-xl"
            title={t('company.imprint-setting.form-input.company-tax-id.title', 'Company tax Id')}
          >
            <Controller
              name={'imprintCompanyTaxId'}
              control={control}
              render={({ field }) => (
                <TextInput
                  type="text"
                  label="company-tax-id"
                  value={field.value ?? ''}
                  name="company-tax-id"
                  error={errors.imprintCompanyTaxId?.message}
                  placeholder={t('company.imprint-setting.form-input.company-tax-id.placeholder', 'Company tax id')}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>

          <FormItem className="max-w-xl" title={t('company.imprint-setting.form-input.phone.title', 'Phone')}>
            <Controller
              name={'imprintPhone'}
              control={control}
              render={({ field }) => (
                <PhoneInput
                  style={{
                    width: '100%',
                    height: '',
                  }}
                  className="block w-full rounded-md border-0 p-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400
                         focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  defaultCountry={'DE'}
                  placeholder={t('company.imprint-setting.form-input.phone.placeholder', 'Enter phone number')}
                  value={field.value ?? ''}
                  error={errors.imprintPhone?.message}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>

          <FormItem className="max-w-xl" title={t('company.imprint-setting.form-input.email.title', 'Email')}>
            <Controller
              name={'imprintEmail'}
              control={control}
              render={({ field }) => (
                <TextInput
                  type="email"
                  label="imprintEmail"
                  value={field.value ?? ''}
                  name="Email"
                  error={errors.imprintEmail?.message}
                  placeholder={t('company.imprint-setting.form-input.email.placeholder', 'Email')}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>
        </FormLayout>
      </CardContent>
    </Card>
  );
}
